{
  "unsubscribe_title": "Se désabonner des e-mails",
  "unsubscribe_message": "Désolé de vous voir partir.",
  "unsubscribe": "Se désabonner",
  "cancel": "Annuler",
  "passwordResetSuccess": "Votre mot de passe a été modifié avec succès.",
  "passwordResetError": "Malheureusement, il y a eu un problème",
  "passwordResetExpired": "Ce lien est invalide ou expiré. Merci de demander un nouvel e-mail de réinitialisation du mot de passe.",
  "passwordResetTooShort": "Utilisez au moins {min} caractères.",
  "passwordResetTooLong": "Ce mot de passe est trop long. Choisissez-en un plus court.",
  "passwordResetTooWeak": "Ce mot de passe est trop facile à deviner. Choisissez-en un autre.",
  "passwordResetTooManyAttempts": "Trop de tentatives. Patientez quelques minutes, puis réessayez.",
  "passwordResetTooManyAttemptsMinutes": "Trop de tentatives. Réessayez dans {minutes} min.",
  "passwordResetNetworkError": "Pas de connexion. Vérifiez votre connexion Internet et réessayez.",
  "passwordResetTryAgain": "Cela n'a pas fonctionné. Réessayez dans un instant.",
  "passwordResetTitle": "Définir un nouveau mot de passe",
  "new_password": "Nouveau mot de passe",
  "confirm_password": "Confirmer le nouveau mot de passe",
  "save": "Enregistrer",
  "error": "Malheureusement, il y a eu un problème",
  "unsubscribeSuccess": "L'action a été réussie",
  "emailChangeLoading": "Changement d'e-mail en cours...",
  "emailChangeSuccess": "L'e-mail a été changé avec succès",
  "emailChangeError": "Malheureusement, il y a eu un problème lors du changement d'e-mail"
}
